// extracted by css-extract-rspack-plugin
export default {"iconToggleSidebar":"_3Q8aP"};